import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
// Import i18n configuration
import './i18n'
// Import PWA cleanup utility
import { completePWACleanup } from './utils/pwaCleanup'
// Import version checking utility
import { initVersionCheck } from './utils/versionCheck'

// Clear app badge if the browser supports the Badging API
// Use type assertion to access the experimental API
const clearBadge = () => {
  // Check if the browser supports the Badging API
  if ('clearAppBadge' in navigator) {
    (navigator as any).clearAppBadge().catch((error: unknown) => {
      console.error('Failed to clear app badge:', error);
    });
  } else if ('setAppBadge' in navigator) {
    // Some browsers only implement setAppBadge
    (navigator as any).setAppBadge(0).catch((error: unknown) => {
      console.error('Failed to clear app badge:', error);
    });
  }
};

// Completely disable PWA functionality
const initializePWACleanup = async () => {
  try {
    await completePWACleanup();
    console.log('PWA cleanup completed successfully');
  } catch (error) {
    console.error('PWA cleanup failed:', error);
  }
};

// Clear badge on startup
clearBadge();

// Initialize PWA cleanup on startup
initializePWACleanup();

// Initialize version checking
initVersionCheck();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
) 